module.exports = __webpack_public_path__ + "static/media/csv-farms.aa217715.svg";